import { PERMISSION_IDS, permissionService } from '@/permissions';

// 为了向后兼容，重新导出一些类型和实例
export { permissionService as permissionController };

// AntDesignPro 的 access 函数
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  permissionService.setRoleIds(currentUser?.roleIds || []);
  permissionService.setSystemAdmin(Boolean(currentUser?.isSystemAdmin));
  permissionService.setCurrentUsername(currentUser?.username);

  // 如果用户信息存在，初始化权限服务
  if (currentUser?.systemPermissions) {
    const systemPerms = currentUser.systemPermissions.map((p) => p.id);
    const exportPerms = currentUser.exportPermissions?.map((p) => p.id) || [];

    permissionService.initialize({
      systemPermissions: systemPerms,
      exportPermissions: exportPerms,
    });
  }

  return {
    // 基础权限
    canRead: true,
    canUpdate: permissionService.hasFunctionPermission('编辑'),
    canDelete: permissionService.hasFunctionPermission('删除'),
    canCreate: permissionService.hasFunctionPermission('新增'),

    // 系统管理权限
    canManageRoles: permissionService.hasSystemPermission(
      PERMISSION_IDS.MANAGE_ROLES,
    ),
    canManageAccounts: permissionService.hasSystemPermission(
      PERMISSION_IDS.MANAGE_ACCOUNTS,
    ),

    // 数据管理权限
    canManageDataPackages: permissionService.hasSystemPermission(
      PERMISSION_IDS.MANAGE_DATA_PACKAGES,
    ),
    canViewPackageLogs: permissionService.hasSystemPermission(
      PERMISSION_IDS.VIEW_PACKAGE_LOGS,
    ),
    canSubpackageDataPackage:
      permissionService.hasFunctionPermission('数据包分包'),
    canUnpackDataPackage: permissionService.hasFunctionPermission('数据包拆包'),
    canMergeDataPackage: permissionService.hasFunctionPermission('数据包组合'),
    canGetFTPDataPackage:
      permissionService.hasFunctionPermission('获取FTP数据包'),

    // 撞库管理权限
    canManageCrackingTasks: permissionService.hasSystemPermission(
      PERMISSION_IDS.MANAGE_CRACKING_TASKS,
    ),
    canManageBasePackages: permissionService.hasSystemPermission(
      PERMISSION_IDS.MANAGE_BASE_PACKAGES,
    ),
    canManageCapabilities: permissionService.hasSystemPermission(
      PERMISSION_IDS.MANAGE_CAPABILITIES,
    ),
    canManageCapabilityAccounts: permissionService.hasSystemPermission(
      PERMISSION_IDS.MANAGE_CAPABILITY_ACCOUNTS,
    ),
    canManageModels: permissionService.hasSystemPermission(
      PERMISSION_IDS.MANAGE_MODELS,
    ),
    canManageProducts: permissionService.hasSystemPermission(
      PERMISSION_IDS.MANAGE_PRODUCTS,
    ),
    canManageOperators: permissionService.hasSystemPermission(
      PERMISSION_IDS.MANAGE_OPERATORS,
    ),

    // 外呼管理权限
    canManageOutboundParties: permissionService.hasSystemPermission(
      PERMISSION_IDS.MANAGE_OUTBOUND_PARTIES,
    ),

    // 导出权限
    canExportPackageLogs: permissionService.hasExportPermission(
      PERMISSION_IDS.EXPORT_PACKAGE_LOGS,
    ),

    // 高级权限检查方法
    hasSystemPermission: (permissionId: number) =>
      permissionService.hasSystemPermission(permissionId),
    hasExportPermission: (permissionId: number) =>
      permissionService.hasExportPermission(permissionId),
    hasFunctionPermission: (functionName: string) =>
      permissionService.hasFunctionPermission(functionName),
    canAccessRoute: (routePath: string) =>
      permissionService.hasRoutePermission(routePath),
    canAccessButton: (buttonPermission: string | number) =>
      permissionService.checkPermission(buttonPermission),
    hasAnyPermission: (permissionIds: number[]) =>
      permissionService.hasAnyPermission(permissionIds),
    hasAllPermissions: (permissionIds: number[]) =>
      permissionService.hasAllPermissions(permissionIds),

    // 工具方法
    checkPermission: (
      permission: string | number,
      type: 'system' | 'function' | 'export' = 'system',
    ) => permissionService.checkPermission(permission, type),
  };
}
